/**
 * NewUserDialog — Schnelles Anlegen eines neuen User-Accounts.
 */
import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from '../../components/ui/dialog';
import { Loader2 } from 'lucide-react';

export const NewUserDialog = ({ open, onOpenChange, form, setForm, creating, onSubmit }) => {
  const setField = (field, value) => setForm({ ...form, [field]: value });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Neuen Benutzer erstellen</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Vorname *</Label>
              <Input value={form.first_name} onChange={(e) => setField('first_name', e.target.value)}
                placeholder="Max" data-testid="input-new-first-name" />
            </div>
            <div className="space-y-2">
              <Label>Nachname *</Label>
              <Input value={form.last_name} onChange={(e) => setField('last_name', e.target.value)}
                placeholder="Mustermann" data-testid="input-new-last-name" />
            </div>
          </div>
          <div className="space-y-2">
            <Label>E-Mail *</Label>
            <Input type="email" value={form.email} onChange={(e) => setField('email', e.target.value)}
              placeholder="max@beispiel.de" data-testid="input-new-email" />
          </div>
          <div className="space-y-2">
            <Label>Passwort *</Label>
            <Input type="password" value={form.password} onChange={(e) => setField('password', e.target.value)}
              placeholder="Mindestens 6 Zeichen" data-testid="input-new-password" />
          </div>
          <div className="flex justify-end gap-2 pt-4">
            <Button variant="outline" onClick={() => onOpenChange(false)}>Abbrechen</Button>
            <Button onClick={onSubmit} disabled={creating} data-testid="btn-create-user">
              {creating && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Erstellen
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
